// Sustemia · Balance Hídrico · rangos de referencia por proceso
// Portado de Sustemia_BalanceHidrico_Modulo_ES_v1_2026-08-11.html (PROCESOS).
//
// Solo los procesos para los que existe un rango publicado que se pudo
// comprobar (ver Fuentes.md §1). El motor NO compara donde no hay
// `bench` — no inventa un rango, no usa el de otra tipología como
// aproximación, y no deja el hueco en blanco: devuelve `sin_benchmark`.

export const PROCESOS_CON_BENCHMARK = {
  acabado_tejido_punto: {
    id: "acabado_tejido_punto",
    nombre: "Acabado de tejido de punto",
    unidadProduccion: "kg",
    bench: { min: 70, max: 120, unidad: "L/kg" },
    fuenteId: "IFC_EHS_TEXTIL",
    localizador: "tabla 4",
  },
  acabado_tejido_plano: {
    id: "acabado_tejido_plano",
    nombre: "Acabado de tejido plano",
    unidadProduccion: "kg",
    bench: { min: 50, max: 100, unidad: "L/kg" },
    fuenteId: "IFC_EHS_TEXTIL",
    localizador: "tabla 4",
  },
  // Valor ilegible en el PDF fuente ("150––80"). NO se supone un número:
  // queda en null con bandera de verificación manual (ver Fuentes.md §1).
  acabado_plano_estampado_algodon: {
    id: "acabado_plano_estampado_algodon",
    nombre: "Acabado plano + estampado, algodón",
    unidadProduccion: "kg",
    bench: null,
    verificacionManualPendiente: true,
    fuenteId: "IFC_EHS_TEXTIL",
    localizador: "tabla 4",
  },
};

export const ADVERTENCIAS_BENCHMARK_IFC = [
  "Proviene de la Comisión Europea 2003 y se basa en un número limitado de instalaciones.",
  "El registro remite al BREF TXT 2023 del JRC, que reemplazó esa versión.",
];

export default { PROCESOS_CON_BENCHMARK, ADVERTENCIAS_BENCHMARK_IFC };
